export default "__VITE_ASSET__DthKl1C6__"